function debounce(ms = 1000) {
  let tid

  return action => {
    clearTimeout(tid)

    tid = setTimeout(action, ms)
  }
}

export default debounce
